export type RaceView = "2d" | "3d";
const key = "neurodrive-race-view-v1";
/** Tab session only. Blocked storage must never prevent a race. */
export function readViewPreference(): RaceView {
  try {
    return sessionStorage.getItem(key) === "3d" ? "3d" : "2d";
  } catch {
    return "2d";
  }
}
export function saveViewPreference(view: RaceView): void {
  try {
    sessionStorage.setItem(key, view);
  } catch {
    /* in-memory app preference remains */
  }
}
